import { SmileFilled, VideoCameraFilled } from "@ant-design/icons";
import { Row, Col } from "antd";
import React, { useContext, useEffect } from "react";
import { NavContext } from "../../state/NavContext";
import { SideContext } from "../../state/SideContext";
import StatisticCard from "./components/StatisticCard";
import WelcomeCard from "./components/WelcomeCard";

const Dashboard = () => {
  const { setActiveIndex, setIsSideBarActive } = useContext(NavContext);
  const { setSideIndex } = useContext(SideContext);

  useEffect(() => {
    setSideIndex("dashboard");
    setActiveIndex("admin");
    setIsSideBarActive(true);
  }, [setActiveIndex, setIsSideBarActive, setSideIndex]);

  return (
    <>
      <div style={{ width: "100%", height: 400 }}>
        <Row gutter={16}>
          <Col span={12}>
            <StatisticCard
              title="Total Movies"
              color="#52c41a"
              icon={<VideoCameraFilled />}
              url="https://backendexample.sanbersy.com/api/data-movie"
            />
          </Col>
          <Col span={12}>
            <StatisticCard
              title="Total Games"
              color="#1890ff"
              icon={<SmileFilled />}
              url="https://backendexample.sanbersy.com/api/data-game"
            />
          </Col>
        </Row>
        <Row style={{ marginTop: 24 }}>
          <Col span={24}>
            <WelcomeCard />
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Dashboard;
